const carSubDirectory = "/car";

export const getAllCarBrandsInInventoryForSalesWebsite = `${carSubDirectory}/getAllCarBrandsInInventoryForSalesWebsite`;

export const getAllCarModelsInInventoryGivenCarBrandId = `${carSubDirectory}/getAllCarModelsInInventoryGivenCarBrandId/:carBrandId`;

export const getAllCarsInInventoryGivenCarModelId = `${carSubDirectory}/getAllCarsInInventoryGivenCarModelId/:carModelId`;

export const getBrandFamilies = `${carSubDirectory}/getBrandFamilies`;

export const getAllActiveCarBrands = `${carSubDirectory}/getAllActiveCarBrands`;

export const getCarModels = `${carSubDirectory}/model`;
